import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  grid-gap: 24px; /* Отступ между элементами */
  grid-row-gap: 24px; /* Отступ между элементами */
  height: calc(100% - 80px); /* Задаем высоту контейнера в высоту экрана */
  max-height: calc(100% - 80px); /* Задаем высоту контейнера в высоту экрана */
  box-sizing: border-box;
  align-content: flex-start;
    
    .calendar-container__enabled .card-events__none:not(.current) {
        opacity: 0.5;
    }

    .calendar-container__enabled .card-events__none {
        pointer-events: none;
    }

    .calendar-container__enabled .card-events__none.current {
        opacity: 0.9;
    }
    
    .calendar-container__enabled.move-mode__enabled .timegrid-slot:hover {
    }
`

export const FullsizeImageContainer = styled.div.attrs({ className: `fullsize-image__container`})`
    transition: opacity .2s ease-in-out;
    opacity: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 100500;
    background: rgba(0, 0, 0, 0.8);
    
    &.enabled {
        pointer-events: unset;
        opacity: 1;
    }

    button {
        z-index: 10;
        position: absolute;
        right: 10px;
        top: 10px;
        border: none;
        outline: none;
        padding: 15px;
        border-radius: 50%;
        background: #333F5F;
        box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        cursor: pointer;
        
        &:hover {
            background: #1f212d;
        }
        
        &:active {
            background: #545660;
        }
        
        img {
            width: 25px;
            filter: contrast(0);
            object-fit: cover;
            height: 25px;
        }
    }
`;

export const FullsizeImageWrapper = styled.div.attrs({className: `fullsize-image__wrapper`})`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    
    overflow: auto;
    
    > img {
        transform: scale(0);
        transition: transform .2s ease-in-out;
        max-height: 80vh;
        max-width: 80vw;
        object-fit: contain;
        cursor: zoom-in;

        &.zoomed {
            transform: scale(2) !important;
            cursor: zoom-out;
        }
        
        &.enabled {
            transform: unset;
        }
    }
`;